import { Divider, styled } from "@mui/material";
import Title from "../../components/Typography/Title";
import NormalText from "../Typography/NormalText";
import clsx from "clsx";

const ContainerStyled = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "6px 8px 6px 24px",
  height: "50px",
  "& .left-section": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  "& .title": {
    padding: 0,
    lineHeight: "22px",
  },
});

const CardSectionTitle = ({
  title,
  subText,
  rightSection,
  classNames = {},
  className,
  shouldHideDivider = false,
}) => {
  return (
    <>
      <ContainerStyled
        className={clsx("card-section-wrapper", className, classNames.wrapper)}
      >
        <div className="left-section">
          <Title className={clsx("title", classNames.title)} title={title} />
          <NormalText text={subText} />
        </div>
        {rightSection}
      </ContainerStyled>
      {!shouldHideDivider && <Divider variant="fullWidth" />}
    </>
  );
};

export default CardSectionTitle;
